exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProseMirror .contentContainerReference{position:relative;margin:12px 0;background-color:#fafafa;border:1px solid #ddd}.ProseMirror .contentContainerReference>.error{color:red}.ProseMirror .contentContainerReference>.warning{color:#b0a000}.ProseMirror .contentContainerReference-toolbar{line-height:22px;padding:0 4px;background-color:#ddd;font-weight:700;color:#000}.ProseMirror .contentContainerReference-title{margin:0 4px;border:none;padding:0 4px;background:#bbb;width:80px;line-height:normal;font-weight:700;color:#000;text-align:right}.ProseMirror .contentContainerReference-body{min-height:2em}", ""]);

// exports
